import type { InsightAction, OverviewDto } from '../../../shared/api';
import { esc, money, shortDate } from '../format';
import { topBar } from './header';

function actionButton(a: InsightAction): string {
  const cls = a.primary ? 'btn primary' : 'btn';
  switch (a.kind) {
    case 'raise':
      return `<button class="${cls}" data-a="raise" data-cat="${esc(a.categoryId)}" data-amt="${a.amountCents}">${esc(a.label)}</button>`;
    case 'dismiss':
      return `<button class="${cls}" data-a="dismiss" data-id="${esc(a.key)}">${esc(a.label)}</button>`;
    case 'confirm-candidate':
      return `<button class="${cls}" data-a="confirm-candidate" data-id="${esc(a.candidateId)}">${esc(a.label)}</button>`;
    case 'decline-candidate':
      return `<button class="${cls}" data-a="decline-candidate" data-id="${esc(a.candidateId)}">${esc(a.label)}</button>`;
    case 'confirm-price':
      return `<button class="${cls}" data-a="confirm-price" ${a.categoryId ? `data-cat="${esc(a.categoryId)}"` : `data-id="${esc(a.itemId ?? '')}"`}>${esc(a.label)}</button>`;
    case 'reject-price':
      return `<button class="${cls}" data-a="reject-price" ${a.categoryId ? `data-cat="${esc(a.categoryId)}"` : `data-id="${esc(a.itemId ?? '')}"`}>${esc(a.label)}</button>`;
    case 'merge':
      return `<button class="${cls}" data-a="merge" data-id="${esc(a.transactionId)}">${esc(a.label)}</button>`;
    case 'keep-separate':
      return `<button class="${cls}" data-a="keep-separate" data-id="${esc(a.transactionId)}">${esc(a.label)}</button>`;
    case 'renewal':
      return `<button class="${cls}" data-a="renewal" data-answer="${a.answer}" data-id="${esc(a.itemId)}"${a.on ? ` data-on="${esc(a.on)}"` : ''}>${esc(a.label)}</button>`;
  }
}

/** "Netflix, $15.49 was logged on Oct 12." */
export const loggedLine = (name: string, amount: string, date: string) => `${name}, ${amount} was logged on ${date}.`;

export function vInsights(d: OverviewDto): string {
  const logged = d.transactions
    .filter((t) => t.source === 'recurring')
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 4);
  const cards = d.insights
    .map(
      (i) =>
        `<article class="ins s${i.severity}"><h3>${esc(i.title)}</h3><p>${esc(i.body)}</p><div class="acts">${i.actions.map(actionButton).join('')}</div></article>`,
    )
    .join('');
  return `${topBar('Insights', 'Only what needs a decision')}
  ${cards || '<p class="empty">Everything is within budget. Insights show up here when spending drifts.</p>'}
  <h2>Logged for you</h2>
  <div class="logged">${
    logged.map((t) => `<p>${esc(loggedLine(t.merchant, money(t.countedCents, 2), shortDate(t.date)))}</p>`).join('') ||
    '<p>Nothing logged for you yet. Items set to log themselves show up here on their due day.</p>'
  }</div>`;
}
